export default {
  title: 'text-color-text-grey font-interMedium text-base mb-2',
  inputWrapper: 'w-[100%] relative',
  input: 'w-[100%] rounded-lg pl-3 py-4 border border-[#CCDCE8] font-inter text-base appearance-none',
  iconWrapper: 'absolute top-[32%] right-[20px] cursor-pointer',
  hidden: 'hidden',
};
